import React, { useState, useMemo } from "react";
import moment from "moment-timezone";
import SearchInput from "./SearchInput";
import ArrowDownIcon from "../../assets/icons/arrowDown";
import PrevIcon from "../../assets/icons/prev";
import NextIcon from "../../assets/icons/next";
import { IoMdEye } from "react-icons/io";
import { getSubType } from "../../Utils/getUserUtitls";

const AttendanceLogTable = ({ data, handleSelectTime }) => {
  const [search, setSearch] = useState("");
  const [monthFilter, setMonthFilter] = useState(moment().format("MMM")); // default: current month
  const [yearFilter, setYearFilter] = useState(moment().year());
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // ✅ Filters
  const filteredData = data.filter((row) => {
    const name = row.first_name + " " + row.last_name;
    return name.toLowerCase().includes(search.toLowerCase());
  });

  const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const statusOptions = [
    { label: "All Status", value: "" },
    { label: "Present", value: "Present" },
    { label: "Absent", value: "Absent" },
    { label: "On Leave", value: "On Leave" },
  ];

  return (
    <div className="w-full rounded-lg">
      {/* Filters */}
      <div className="flex justify-between items-start md:flex-row gap-3 mb-4">
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by Name..."
          fontSize="sm"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="table-auto w-full text-sm">
          <thead>
            <tr className="h-[52px] bg-white border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-4 text-left text-sm font-semibold">S No.</th>
              <th className="px-4 text-left text-sm font-semibold">Name</th>
              <th className="px-4 text-center text-sm font-semibold">
                CheckIn
              </th>
              <th className="px-4 text-center text-sm font-semibold">
                Check Out
              </th>
              {/* <th className="px-4 text-center text-sm font-semibold">
                Working Hours
              </th> */}
              <th className="px-4 text-center text-sm font-semibold">
                Login Location
              </th>
              <th className="px-4 text-center text-sm font-semibold">
                Login Status
              </th>
              <th className="px-4 text-center text-sm font-semibold">Status</th>
              <th className="px-4 text-center text-sm font-semibold"></th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((row, idx) =>
                row.is_holiday ? (
                  <tr key={idx} className="relative hover:bg-[#f9f9f9] border">
                    <td className="relative text-left py-3 px-4">
                      <p className="text-sm">
                        {(currentPage - 1) * rowsPerPage + idx + 1}
                      </p>
                    </td>
                    <td className="text-sm text-left py-3 px-4">
                      {row.first_name + " " + row.last_name}
                    </td>
                    <td
                      colSpan="6"
                      className="text-center py-3 px-3 font-medium bg-gray-100 text-gray-500"
                    >
                      {row?.holiday_title}
                    </td>
                  </tr>
                ) : (
                  <tr key={idx} className="relative hover:bg-[#f9f9f9]">
                    <td className="relative text-left py-3 px-4">
                      <p className="text-sm">
                        {(currentPage - 1) * rowsPerPage + idx + 1}
                      </p>
                    </td>
                    <td className="text-sm text-left py-3 px-4">
                      {row.first_name + " " + row.last_name}
                    </td>
                    <td className="text-sm text-center py-3">
                      {row.clock_in_time ? (
                        <div className="inline-block">
                          {row.clock_in_time
                            ? moment
                                .utc(row.clock_in_time)
                                .tz(
                                  row.location_id === 1
                                    ? "Asia/Dubai"
                                    : row.location_id === 2
                                    ? "Asia/Kolkata"
                                    : "UTC"
                                )
                                .format("hh:mm A")
                            : "-"}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-sm text-center py-3">
                      {row.clock_out_time ? (
                        <div className="inline-block">
                          {row.clock_out_time
                            ? moment
                                .utc(row.clock_out_time)
                                .tz(
                                  row.location_id === 1
                                    ? "Asia/Dubai"
                                    : row.location_id === 2
                                    ? "Asia/Kolkata"
                                    : "UTC"
                                )
                                .format("hh:mm A")
                            : "-"}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    {/* <td className="text-sm text-center py-3">
                    {`${row.working_hours ? row.working_hours : 0} hrs`}
                  </td> */}
                    <td
                      className="text-sm text-center py-3"
                      title={
                        row.location_data
                          ? ["suburb", "town", "state"]
                              .map(
                                (k) =>
                                  JSON.parse(JSON.parse(row.location_data))?.[k]
                              )
                              .filter(Boolean)
                              .join(", ")
                          : "-"
                      }
                    >
                      {row.location_data
                        ? JSON.parse(JSON.parse(row.location_data)).country
                        : "-"}
                    </td>
                    <td className="text-sm text-center py-3">
                      {row.login_status === "on_time" ? (
                        <span className="flex justify-center items-center w-[150px] px-2 py-1 mx-auto rounded bg-[#32936f]/[0.16] text-[#519c66]">
                          On Time
                        </span>
                      ) : (
                        <span className="flex justify-center items-center w-[150px] px-2 py-1 mx-auto rounded bg-[#de2b26]/10 text-[#142b70]">
                          {row.login_status === "late"
                            ? "Late"
                            : row.login_status
                            ? "Half Day"
                            : "Not Logged In"}
                        </span>
                      )}
                    </td>
                    <td className="text-sm text-center py-3 font-medium">
                      {row.attendance_status === "On Leave" ? (
                        <span className="flex flex-col justify-center items-center px-2 py-1 mx-auto rounded bg-[#de2b26]/10 text-[#142b70]">
                          {getSubType(row?.sub_type) + " Leave"}
                        </span>
                      ) : row.attendance_status === "Present" ? (
                        <span className="flex justify-center items-center px-2 py-1 mx-auto rounded bg-[#32936f]/[0.16] text-[#519c66]">
                          {row.attendance_status}
                        </span>
                      ) : (
                        <span className="flex flex-col justify-center items-center px-2 py-1 mx-auto rounded bg-[#de2b26]/10 text-[#142b70]">
                          {row.attendance_status}
                        </span>
                      )}
                    </td>
                    <td className="text-sm text-center py-3 font-medium">
                      {(row.clock_in_photo || row.clock_out_photo) && (
                        <IoMdEye
                          className="text-[#c30f0a] text-lg cursor-pointer"
                          onClick={() =>
                            handleSelectTime({
                              checkInImg: row.clock_in_photo,
                              checkOutImg: row.clock_out_photo,
                              text: "Check In/Out Image",
                            })
                          }
                        />
                      )}
                    </td>
                  </tr>
                )
              )
            ) : (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4">
        <div className="relative w-[190px] h-[30px] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="flex items-center h-[26px] px-[10px] rounded-lg bg-[#f9f9f9] cursor-pointer relative">
              <select
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-transparent text-xs focus:outline-none cursor-pointer appearance-none pr-5"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
              <ArrowDownIcon
                iconClass="absolute right-2 pointer-events-none"
                color="#142b70"
              />
            </div>
            <p className="text-sm text-[#142b70]/80">of {totalPages} pages</p>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="disabled:opacity-40"
            >
              <PrevIcon color="#142b70" />
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="disabled:opacity-40"
            >
              <NextIcon color="#142b70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceLogTable;
